import { render } from "./become-contact-or-user.vue?vue&type=template&id=6d90d142"
import script from "./become-contact-or-user.vue?vue&type=script&lang=js"
export * from "./become-contact-or-user.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__